import { loaderContainer } from "../utils/style";
import loader from '../assets/icons/loader.png'
import { useState } from "react";

export var setLoader;

function Loader() {
    const [ showLoader, setShowLoader ] = useState(false)

    setLoader = function(state) {
        setShowLoader(state)
    }

    return(
        showLoader &&
        <div className={loaderContainer}>
            <img src={loader} height={50} width={50}/>
        </div>
    )
}

export default Loader;